import React from "react";
import {styled} from "@mui/material/styles";

import {useFavorite} from "@/hooks/useFavorite.jsx";
import {COLOR_BLUE} from "@/themes/colors.jsx";
import UncheckedIcon from '@svg/star-16.svg';
import CheckedIcon from '@svg/star-16-checked.svg';

export default function FavoriteButton({data, ...props}) {
    const {addFavorite, removeFavorite, isFavorite} = useFavorite();

    const id = data;
    const checked = !!isFavorite(id);

    return (
        <ButtonElement
            onClick={(event) => {
                event.preventDefault();
                isFavorite(id) ? removeFavorite(id) : addFavorite(id);
            }}
            {...props}
        >
            {checked ? <CheckedIcon className="me-1"/> : <UncheckedIcon className="me-1"/>} Favorite
        </ButtonElement>
    )
}

const ButtonElement = styled('button')({
    border: 'none',
    backgroundColor: 'transparent',
    color: COLOR_BLUE,
    transition: 'background-color 0.3s linear',
    textDecoration: 'none',
    textAlign: 'center',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    fontSize: '15px',
    fontWeight: '800',
});
